import React, { useEffect, useState } from "react";
import { Container, Row, Col } from "react-bootstrap";
import { db } from "../firebase";
import { collection, query, getDocs } from "firebase/firestore";
import Viewer from '../Components/Viewer';

function Courses() {
  const [coursesData, setCoursesData] = useState([]); // Rename to coursesData

  useEffect(() => {
    const fetchData = async () => {
      const q = query(collection(db, "Courses"));
      const querySnapshot = await getDocs(q);

      const courses = querySnapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));

      setCoursesData(courses);

      console.log("----------->", courses);
    };

    fetchData();
  }, []);

  return (
    <div>
      <section id="courses-hero" className="bg-red-500 py-20">
        <Container>
          <Row className="">
            <Col sm={12} md={12}>
              <h1 className="text-4xl font-semibold mb-4">
                Explore Our Courses
              </h1>
              <p className="text-lg">
                Choose from a variety of courses designed to empower you in your
                journey of skill development and education.
              </p>
              <h2 className="text-3xl font-semibold mb-4">Course Details</h2>
            </Col>
          </Row>
        </Container>
      </section>
      {coursesData.map((course) => (
        <section key={course.id} id="course-details" className="py-16">
          <Container>
            <Row className="p-2">
              <Col sm={12} md={8}>
                <Row>
                  <Col md={6} className="py-2">
                    <h4 className="text-lg font-semibold">{course.field1}</h4>
                    <Viewer html={course.field2} />
                  </Col>
                </Row>
              </Col>
              <Col sm={12} md={4}>
                {/* Course images */}
                {course?.images && course.images.length > 0 ? (
                  <div className="course-images">
                    <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(150px, 1fr))", gap: "10px" }}>
                      {course.images.map((imageUrl, index) => (
                        <img
                          key={index}
                          src={imageUrl}
                          alt={`${course.field1} - Image ${index + 1}`}
                          className="rounded-lg shadow-md w-100"
                          style={{ 
                            aspectRatio: "1",
                            objectFit: "cover",
                            maxHeight: "200px"
                          }}
                        />
                      ))}
                    </div>
                  </div>
                ) : course?.field3 ? (
                  // Fallback to single image for backward compatibility
                  <img
                    src={course.field3}
                    alt={course.field1}
                    className="mx-auto rounded-lg shadow-md w-100"
                  />
                ) : null}
              </Col>
            </Row>
          </Container>
        </section>
      ))}
    </div>
  );
}

export default Courses;
